import { render } from "./paidMembers.vue?vue&type=template&id=794170b8&scoped=true"
import script from "./paidMembers.vue?vue&type=script&lang=js"
export * from "./paidMembers.vue?vue&type=script&lang=js"

import "./paidMembers.vue?vue&type=style&index=0&id=794170b8&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794170b8"]])

export default __exports__